// extracted by mini-css-extract-plugin
module.exports = {"bvTrustMark":"az_Gad","image":"az_Had","bvTooltip":"az_Iad","textTooltip":"az_Jad","bvLink":"az_Kad"};